import React, { useState, useEffect, FC } from "react";
import { YhBox } from "@/components/YhBox";
import { Table, Button } from "antd";
import { ColumnsType } from "antd/lib/table";
import { IStoreInventoryDetail } from "../../stockStatisticTypes";
import { stockStatisticService } from "../../stockStatisticService";
import { useRecordGoodsModel } from "./recordGoodsModel";
import useGlobalModel from '@/model/globalModel';

enum ShopTypeEnum {
	VRM,
	SCM,
	BCMS
}
export function StockTable() {
	const {
		goodsRecordModal: { materialCode, materialName }
	} = useRecordGoodsModel();
	const { user: { shopId } } = useGlobalModel();
	//对应商品的库存
	const [goodsStock, setGoodsStock] = useState<IStoreInventoryDetail[]>([]);
	const [selectedRowKeys, setSelectedRowKeys] = useState<string>("");
	const [goodsShopStock, setGoodsShopStock] = useState<IStoreInventoryDetail[]>([]);
	const [shopType, setShopType] = useState<ShopTypeEnum>(ShopTypeEnum.SCM)

	useEffect(() => {
		shopLoadData();
	}, [])

	const shopLoadData = async () => {
		let data = {
			materialCode,
			// shopId,
		}
		let { retData } = await stockStatisticService.scm2Inventory(data);
		let newData = retData.map(item => {
			return {
				...item,
				inventoryNum: item.totalInventoryQuantity,
				inventoryOccupied: item.totalOccupyNum,
				availableStock: item.availableNum
			}
		});
		// const { records } = retData;

		// if (records.length) {
		// 	let row = records[0];
		// 	setSelectedRowKeys(row.id);
		// 	loadData(row.shopId);
		// }
		setGoodsStock(newData ?? [])

	}
	const setShopDataSource = async (shopTypes: ShopTypeEnum) => {
		setShopType(shopTypes)
		let data: IStoreInventoryDetail[] = [];
		switch (shopTypes) {
			case ShopTypeEnum.SCM:
				const { retData: scmRetData } = await stockStatisticService.scm2Inventory({ materialCode });
				data = scmRetData.map(item => {
					return {
						...item,
						inventoryNum: item.totalInventoryQuantity,
						inventoryOccupied: item.totalOccupyNum,
						availableStock: item.availableNum
					}
				});
				break;
			case ShopTypeEnum.VRM:
				const { retData: vrmRetData } = await stockStatisticService.vrm2Inventory(materialCode);
				data = vrmRetData;
				break;
			case ShopTypeEnum.BCMS:
				const { retData: bcmRetData } = await stockStatisticService.bcmInventory(materialCode);
				data = bcmRetData;
				break;
			default:
				break;
		}
		setGoodsStock(data ?? [])
	}

	const title = <>
		<Button
			className={`mr-5 ${shopType === ShopTypeEnum.SCM ? "tab-buts-active" : ""}`}
			type="link"
			shape="round"
			onClick={() => setShopDataSource(ShopTypeEnum.SCM)}
		>供应链系统</Button>
		<Button
			className={`mr-5 ${shopType === ShopTypeEnum.VRM ? "tab-buts-active" : ""}`}
			type="link"
			shape="round"
			onClick={() => setShopDataSource(ShopTypeEnum.VRM)}
		>云修系统</Button>
		<Button
			className={`mr-5 ${shopType === ShopTypeEnum.BCMS ? "tab-buts-active" : ""}`}
			type="link"
			shape="round"
			onClick={() => setShopDataSource(ShopTypeEnum.BCMS)}
		>客车系统</Button>
	</>

	const columnsStock: ColumnsType<IStoreInventoryDetail> = [
		{
			title: '序号',
			width: 60,
			align: "center",
			dataIndex: "totalTxt",
			render: (t: any, r: any, i: number) => i + 1
		},
		{
			title: '从属门店',
			width: 120,
			dataIndex: 'shopName',
		},
		...((str) => {
			if (str) {
				return [{
					title: '所属仓库',
					width: 100,
					dataIndex: 'warehouseName',
				}]
			} else {
				return []
			}

		})(shopType === ShopTypeEnum.SCM),
		// {
		// 	title: '所属仓库',
		// 	width: 100,
		// 	dataIndex: 'warehouseName',
		// },
		{
			title: '库存',
			width: 80,
			dataIndex: 'inventoryNum',
		},
		{
			title: '占用库存',
			width: 80,
			dataIndex: 'inventoryOccupied',
		},
		{
			title: '可用库存',
			width: 80,
			dataIndex: 'availableStock',
		},
	];

	const columnsShelf: ColumnsType<IStoreInventoryDetail> = [
		{
			title: '库存',
			width: 150,
			align: "center",
			dataIndex: 'inventoryNum',
		}, {
			title: '占用库存',
			width: 150,
			align: "center",
			dataIndex: 'holdNum',
		}, {
			title: '货位',
			width: 160,
			align: "center",
			dataIndex: 'shelfCode',
		}, {
			title: '仓库',
			width: 160,
			align: "center",
			dataIndex: 'warehouseName',
		}
	];

	return <div className="flex">
		<YhBox style={{ marginBottom: "15px" }} title={title}>
			<Table
				// rowKey={record => record.id}
				columns={columnsStock}
				dataSource={goodsStock}
				pagination={false}
				onRow={record => ({
					// onClick: () => { setSelectedRowKeys(record.id); loadData(record.shopId); }
				})}
				// rowClassName={(record, index) => record.id === selectedRowKeys ? "table-select-row" : ""}
				scroll={{ x: 'max-content', y: 400 }}
			/>
		</YhBox>
		{/* <YhBox style={{ margin: "0 0 15px 15px" }} title="门店下属仓库库存列表">
			<Table
				rowKey={record => record.id}
				columns={columnsShelf}
				dataSource={goodsShopStock}
				pagination={false}
				scroll={{ x: 'max-content', y: 400 }}
			/>
		</YhBox> */}
	</div>
}